import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getReceipt = (params: {
  invoiceId: number;
  type: "opd" | "ipd" | "pathology" | "pharmacy";
}) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/receipts`, { params: snakeParams });
};

export const getPharmacyReceiptPdf = (params: { invoiceId: number }) => {
  const snakeParams = camelToSnake(params);
  return api.get(`${BASE_URL}/api/v1/receipts/pharmacy/pdf`, {
    params: snakeParams,
  });
};
